<style lang="scss" src='./StationDetails.scss' scoped></style>
<template src="./StationDetails.html"></template>

<script>

import StationAlerts from '@/views/stations/details/alerts/StationAlerts.vue';
import StationChart from '@/views/stations/details/chart/StationChart.vue';
import StationData from '@/views/stations/details/data/StationData.vue';
import StationMap from '@/views/stations/details/map/StationMap.vue';

import { cleanUpStation } from '@/api/index';

export default {
  name: 'StationDetails',
  components: {
      StationAlerts,
      StationChart,
      StationData,
      StationMap
  },
  props: {
    station: {
      required: false,
    },
  },
  data() {
    return ({
    });
  },
  computed: {},

  methods: {
  },

  beforeCreate() {},

  created() {},

  mounted() {},
};
</script>
